import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { initDatadogLog } from 'utils/helpers/dataDogLog'
import { setupMaintenance } from '@astronautsid/wpe-utils/helpers/maintenance'
import { remoteConfig } from 'config/firebase'

const {
  REACT_APP_DATADOG_CLIENT_TOKEN,
  REACT_APP_DATADOG_SITE,
  REACT_APP_DATADOG_SESSION_SAMPLE_RATE,
  REACT_APP_ENV,
  REACT_APP_VERSION,
  REACT_APP_NAME,
  REACT_APP_ENABLE_DATADOG,
  REACT_APP_ENABLE_REMOTE_CONFIG_MAINTENANCE,
  NODE_ENV,
} = process.env

const useAppInit = () => {
  const location = useLocation()

  useEffect(() => {
    if (REACT_APP_ENABLE_DATADOG) {
      initDatadogLog({
        clientToken: REACT_APP_DATADOG_CLIENT_TOKEN as string,
        site: REACT_APP_DATADOG_SITE,
        forwardErrorsToLogs: false,
        sessionSampleRate: Number(REACT_APP_DATADOG_SESSION_SAMPLE_RATE),
        env: REACT_APP_ENV === 'production' ? 'production' : 'development',
        service: REACT_APP_NAME,
        version: REACT_APP_VERSION,
      })
    }
  }, [])

  useEffect(() => {
    const onUpdateServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        const registration = await navigator.serviceWorker.getRegistration()
        if (registration) {
          registration.update()
        }
      }
    }

    onUpdateServiceWorker()
  }, [location.pathname])

  useEffect(() => {
    if (NODE_ENV === 'development' || REACT_APP_ENABLE_REMOTE_CONFIG_MAINTENANCE !== 'true') return

    const unsub = setupMaintenance(remoteConfig)
    // eslint-disable-next-line consistent-return
    return () => unsub()
  }, [])
}

export default useAppInit
